import { graphql } from "msw";
import { mockProduct } from "./mockProduct";
import {
  FomoProductRecommendationsQuery,
  Product,
  Offer,
} from "@cart-app/generated/graphql";

const recommendedProduct: Product = {
  ...mockProduct,
  id: "241428",
  title: "Ray-Ban Hexagonal Flat Lenses Sunglasses - Gold/Grey",
  bestOffer: {
    ...(mockProduct.bestOffer as Offer),
    purchasableQuantity: 2,
  },
};

export const handler = graphql.query<FomoProductRecommendationsQuery>(
  "FomoProductRecommendations", // CartUpsellRecommendation.tsx
  (_request, response, context) =>
    response(
      context.data({
        __typename: "Query" as const,
        fomoProductRecommendations: {
          __typename: "FomoProductRecommendationsResponse" as const,
          products: [recommendedProduct],
          metaData: {
            hydrationErrorCount: 0,
            preHydrationCount: 1,
            postHydrationCount: 1,
            sourceProductIds: [222, 333],
            __typename: "RecommenderMetaData" as const,
          },
        },
      })
    )
);
